export enum ColorValue {
  r,
  g,
  b,
  alpha
}
